export const receiptDocument = {
    "formatVersion": 2,
    "receiptId": "everyday-health-contract-receipt-2026-v3-profit-margin-v2-local-exact46",
    "status": "human-reviewed-local-exact46-contract",
    "approvedOn": "2026-08-24",
    "approvedByRole": "HepHesapla yerel QA içerik, metodoloji ve katalog bütünlüğü incelemesi",
    "independencePolicy": "Bu yerel QA receipt runtime seed nesnesinden çalışma anında üretilmez. Deterministik tören yalnız dondurulmuş Exact46 katalog baytlarını yeniden üretir; production yayın yetkisi vermez.",
    "publisherOracleBoundary": "Publisher resmî oracle ayrı dosya ve ayrı yayın kapısıdır; bu yerel QA receipt production signer veya canlı publish onayı değildir.",
    "exactToolOrder": [
        "lpg-payback",
        "fuel-consumption",
        "profit-margin",
        "basal-metabolic-rate",
        "historical-ideal-weight-reference"
    ],
    "catalogBaseline": {
        "baseToolCount": 41,
        "fullToolCount": 46,
        "base41CanonicalSha256": "0e2f78eb63b62975ddbab0b4cee78760949ef7f052f9e8d5cd3c2ca2327887c1",
        "base41JsonSha256": "f4f4b56fe30fb61789241898897544a22bb668fe6a4e1291bdaf58c33a03253d",
        "exact46CanonicalSha256": "90590851f668a02d4e86e4a6f823bbf2d03389bd352ad981b6635658c87a80df",
        "exact46JsonSha256": "a4762a7554151dafaefe8e636174de28422c5e99fc56e2ccec38ad37f514ceda",
        "exactCategory": {
            "percentage": {
                "id": "matematik",
                "label": "Matematik"
            },
            "salary": {
                "id": "bireysel-finans",
                "label": "Bireysel Finans"
            },
            "hgs-toll": {
                "id": "arac-emlak-yasam",
                "label": "Araç, Emlak ve Yaşam"
            }
        }
    },
    "oracle": {
        "oracleId": "everyday-health-official-2026-v2-profit-margin",
        "canonicalSha256": "704d7086352ae2550e13692a86355c0fb8ea5024b64524558f423432540ca06f",
        "recordSha256": {
            "lpg-payback": "8c7be6870b706f70793116004876748aeaf1ef8bfac4927ba029dbc1d68bfcc1",
            "fuel-consumption": "e2e2f7bbf16d18df331f9062b7420679986c8b88f51ba4b5e723bd4c6ca883a9",
            "profit-margin": "b205183c28e3b1089666c96c342af942cbd6a93e77dd782998577f0f0a680cc2",
            "basal-metabolic-rate": "806259ebff62098fc7e9c590a0fcd442f8240cdb8d02d3a87dcf909664953329",
            "historical-ideal-weight-reference": "37d199556d55fcc2ce81e0afe2beccfbc164ad9af654d8a250180a2b13ef36b7"
        }
    },
    "frozenCoreSourceSha256": {
        "packages/calculation-core/src/everyday.ts": "4dc31e8a31fa517ee8e1879813fd55a2907954c00083ff6299d170e941ae12ed",
        "packages/calculation-core/src/health-reference.ts": "c9c7a10a7b133c2056ce7411192f329ae99ec5db774fb9582bb8a9178574cffd"
    },
    "tools": [
        {
            "canonicalToolId": "arac-emlak-yasam.lpg-donusum-amortisman-hesaplama",
            "runtimeToolId": "lpg-payback",
            "contractCanonicalSha256": "ff22492eb98fdeb5f0e9bdb517fced7e5d54bfd7502ff31446d4fe003ad36c5e",
            "oracleRecordSha256": "8c7be6870b706f70793116004876748aeaf1ef8bfac4927ba029dbc1d68bfcc1",
            "contract": {
                "toolId": "lpg-payback",
                "slug": "lpg-donusum-amortisman-hesaplama",
                "path": "/arac-emlak-yasam/lpg-donusum-amortisman-hesaplama",
                "category": {
                    "id": "arac-emlak-yasam",
                    "label": "Araç, Emlak ve Yaşam"
                },
                "classification": "timeless",
                "engineId": "lpg-payback-v1",
                "schemaVersion": "1.0.0",
                "contentVersion": "2026.8.20",
                "configVersion": "1.0.0",
                "effectiveFrom": "2026-08-20",
                "effectiveTo": null,
                "minAppVersion": "0.1.0",
                "updateCadence": {
                    "mode": "method-change-only",
                    "days": null,
                    "reviewAfter": null,
                    "specialMonths": [],
                    "note": "Hesap yöntemi değişmedikçe kural güncellemesi gerekmez; yıllık işlev ve metin QA'sı yapılabilir."
                },
                "sources": [],
                "inputSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "conversionCost",
                            "type": "number",
                            "label": "Dönüşüm Maliyeti",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 25000",
                            "unit": "TL",
                            "minimum": 1e-9,
                            "exclusiveMinimum": false,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "extraOneOffCost",
                            "type": "number",
                            "label": "Ek Tek Seferlik Masraf",
                            "required": false,
                            "defaultValue": 0,
                            "placeholder": "Ör: 5000",
                            "unit": "TL",
                            "minimum": 0,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "gasolineConsumptionL100Km",
                            "type": "number",
                            "label": "Benzin Tüketimi",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 8",
                            "unit": "L/100 km",
                            "minimum": 1e-9,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 3,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "lpgConsumptionL100Km",
                            "type": "number",
                            "label": "LPG Tüketimi",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 9,6",
                            "unit": "L/100 km",
                            "minimum": 1e-9,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 3,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "gasolinePricePerLitre",
                            "type": "number",
                            "label": "Benzin Litre Fiyatı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 50",
                            "unit": "TL/L",
                            "minimum": 1e-9,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 4,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "lpgPricePerLitre",
                            "type": "number",
                            "label": "LPG Litre Fiyatı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 25",
                            "unit": "TL/L",
                            "minimum": 1e-9,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 4,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "monthlyDistanceKm",
                            "type": "number",
                            "label": "Aylık Mesafe",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 1500",
                            "unit": "km",
                            "minimum": 1e-9,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        }
                    ]
                },
                "resultSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "conversionCost",
                            "type": "money",
                            "label": "Dönüşüm Maliyeti",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "extraOneOffCost",
                            "type": "money",
                            "label": "Ek Masraf",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "gasolineConsumptionL100Km",
                            "type": "number",
                            "label": "Benzin Tüketimi",
                            "unit": "L/100 km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "lpgConsumptionL100Km",
                            "type": "number",
                            "label": "LPG Tüketimi",
                            "unit": "L/100 km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "gasolinePricePerLitre",
                            "type": "money",
                            "label": "Benzin Litre Fiyatı",
                            "unit": "TL/L",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "lpgPricePerLitre",
                            "type": "money",
                            "label": "LPG Litre Fiyatı",
                            "unit": "TL/L",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "monthlyDistanceKm",
                            "type": "number",
                            "label": "Aylık Mesafe",
                            "unit": "km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "gasolineCostPerKm",
                            "type": "money",
                            "label": "Benzin Kilometre Maliyeti",
                            "unit": "TL/km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "lpgCostPerKm",
                            "type": "money",
                            "label": "LPG Kilometre Maliyeti",
                            "unit": "TL/km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "savingsPerKm",
                            "type": "money",
                            "label": "Kilometre Başına Tasarruf",
                            "unit": "TL/km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "savingsPer100Km",
                            "type": "money",
                            "label": "100 km Tasarrufu",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "investment",
                            "type": "money",
                            "label": "Toplam Yatırım",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "monthlySavings",
                            "type": "money",
                            "label": "Aylık Tasarruf",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "annualSavings",
                            "type": "money",
                            "label": "Yıllık Tasarruf",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "paybackPossible",
                            "type": "boolean",
                            "label": "Amortisman Mümkün",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "paybackDistanceKm",
                            "type": "number",
                            "label": "Amortisman Mesafesi",
                            "unit": "km",
                            "nullable": true,
                            "prominent": true
                        },
                        {
                            "id": "paybackMonths",
                            "type": "number",
                            "label": "Amortisman Süresi",
                            "unit": "ay",
                            "nullable": true,
                            "prominent": true
                        }
                    ]
                },
                "content": {
                    "title": "LPG Dönüşüm Amortisman Hesaplama",
                    "shortTitle": "LPG Amortismanı",
                    "summary": "Kullanıcının girdiği dönüşüm maliyeti, benzin ve LPG tüketimi, litre fiyatları ile aylık mesafeden tasarruf ve geri ödeme senaryosu hesaplar.",
                    "method": "Benzin ve LPG için kilometre maliyeti ayrı ayrı bulunur. İki maliyet arasındaki olumlu fark kilometre başına tasarruftur. Dönüşüm ve tek seferlik ek masrafların toplamı bu tasarrufa bölünerek geri ödeme mesafesi; aylık mesafeyle de yaklaşık geri ödeme süresi hesaplanır. LPG kilometre maliyeti daha düşük değilse geri ödeme mümkün gösterilmez.",
                    "limitations": [
                        "Yalnız kullanıcı girdili aritmetik; dış tarife yok. Fiyat, tüketim, kilometre, dönüşüm ve ek masraf değerlerinin tamamı kullanıcı tarafından girilir.",
                        "Sonuç teknik uyumluluk veya tasarruf garantisi değildir; kit uygunluğu, ruhsat işlemi, bakım, arıza, garanti, sigorta ve ikinci el değeri kendiliğinden hesaba katılmaz.",
                        "Akaryakıt fiyatı, tüketim veya aylık mesafe değiştiğinde sonuç otomatik güncellenmez; güncel değerlerle yeniden hesaplanmalıdır."
                    ],
                    "faqs": [
                        {
                            "question": "Geri ödeme süresi neden hesaplanmadı?",
                            "answer": "Girilen LPG kilometre maliyeti benzin kilometre maliyetinden düşük değilse pozitif tasarruf oluşmaz. Bu durumda araç geri ödeme mesafesi ve ay sayısı üretmez."
                        },
                        {
                            "question": "Akaryakıt fiyatları değişince sonuç otomatik güncellenir mi?",
                            "answer": "Hayır. Araç canlı fiyat kaynağına bağlanmaz; yeni benzin ve LPG litre fiyatlarını kendiniz girerek hesabı yenilemeniz gerekir."
                        },
                        {
                            "question": "Bakım ve ruhsat giderleri hesaba dahil midir?",
                            "answer": "Yalnız tek seferlik ek masraf alanına yazdığınız tutar yatırım toplamına eklenir. Sonradan doğabilecek bakım, arıza, ruhsat veya sigorta giderleri otomatik eklenmez."
                        }
                    ],
                    "sourcePanel": {
                        "title": "Kaynak ve veri kapsamı",
                        "summary": "Dış tarife kaynağı yoktur; tüm fiyat, tüketim, mesafe ve masraf değerleri kullanıcı girdisidir. sourceIds boş kalır.",
                        "sourceIds": [],
                        "notes": [
                            "Yakıt fiyatı veya araç tüketimi uzaktan alınmaz.",
                            "Yöntem değişmedikçe yalnız yıllık işlev ve metin kontrolü gerekir."
                        ]
                    }
                },
                "config": {
                    "kind": "lpg-payback-v1",
                    "metadata": {
                        "calculatorId": "lpg-payback",
                        "version": "1.0.0",
                        "effectiveFrom": "2026-08-20",
                        "lastVerifiedAt": "2026-08-20",
                        "sources": [],
                        "notes": [
                            "Fiyat, tüketim, kilometre ve masraf değerlerinin tamamı kullanıcı girdisidir; piyasa fiyatı varsayılmaz.",
                            "Sonuç teknik uygunluk veya tasarruf garantisi değildir."
                        ]
                    },
                    "maxAbsoluteInput": 1000000000
                },
                "lastReviewed": "2026-08-20"
            }
        },
        {
            "canonicalToolId": "arac-emlak-yasam.yakit-tuketimi-hesaplama",
            "runtimeToolId": "fuel-consumption",
            "contractCanonicalSha256": "e704abce735192b10fce1eb32257e166a4421db6335533541a2b155e04f65df6",
            "oracleRecordSha256": "e2e2f7bbf16d18df331f9062b7420679986c8b88f51ba4b5e723bd4c6ca883a9",
            "contract": {
                "toolId": "fuel-consumption",
                "slug": "yakit-tuketimi-hesaplama",
                "path": "/arac-emlak-yasam/yakit-tuketimi-hesaplama",
                "category": {
                    "id": "arac-emlak-yasam",
                    "label": "Araç, Emlak ve Yaşam"
                },
                "classification": "timeless",
                "engineId": "fuel-consumption-v1",
                "schemaVersion": "1.0.0",
                "contentVersion": "2026.8.20",
                "configVersion": "1.0.0",
                "effectiveFrom": "2026-08-20",
                "effectiveTo": null,
                "minAppVersion": "0.1.0",
                "updateCadence": {
                    "mode": "method-change-only",
                    "days": null,
                    "reviewAfter": null,
                    "specialMonths": [],
                    "note": "Hesap yöntemi değişmedikçe kural güncellemesi gerekmez; yıllık işlev ve metin QA'sı yapılabilir."
                },
                "sources": [],
                "inputSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "fuelType",
                            "type": "select",
                            "label": "Yakıt Türü",
                            "required": true,
                            "defaultValue": "benzin",
                            "placeholder": null,
                            "unit": null,
                            "minimum": null,
                            "maximum": null,
                            "maxDecimalPlaces": null,
                            "options": [
                                {
                                    "value": "benzin",
                                    "label": "Benzin"
                                },
                                {
                                    "value": "motorin",
                                    "label": "Motorin"
                                },
                                {
                                    "value": "lpg",
                                    "label": "LPG"
                                }
                            ],
                            "visibleWhen": null
                        },
                        {
                            "id": "distanceKm",
                            "type": "number",
                            "label": "Mesafe",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 400",
                            "unit": "km",
                            "minimum": 1,
                            "maximum": 20000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "consumptionL100Km",
                            "type": "number",
                            "label": "Ortalama Tüketim",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 7",
                            "unit": "L/100 km",
                            "minimum": 1,
                            "maximum": 50,
                            "maxDecimalPlaces": 3,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "pricePerLitre",
                            "type": "number",
                            "label": "Litre Fiyatı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 45",
                            "unit": "TL/L",
                            "minimum": 1,
                            "maximum": 500,
                            "maxDecimalPlaces": 4,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "direction",
                            "type": "radio",
                            "label": "Yol Yönü",
                            "required": true,
                            "defaultValue": "tekYon",
                            "placeholder": null,
                            "unit": null,
                            "minimum": null,
                            "maximum": null,
                            "maxDecimalPlaces": null,
                            "options": [
                                {
                                    "value": "tekYon",
                                    "label": "Tek Yön"
                                },
                                {
                                    "value": "gidisDonus",
                                    "label": "Gidiş Dönüş"
                                }
                            ],
                            "visibleWhen": null
                        }
                    ]
                },
                "resultSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "fuelType",
                            "type": "text",
                            "label": "Yakıt Türü",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "distanceKm",
                            "type": "number",
                            "label": "Girilen Mesafe",
                            "unit": "km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "consumptionL100Km",
                            "type": "number",
                            "label": "Ortalama Tüketim",
                            "unit": "L/100 km",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "pricePerLitre",
                            "type": "money",
                            "label": "Litre Fiyatı",
                            "unit": "TL/L",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "direction",
                            "type": "text",
                            "label": "Yol Yönü",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "effectiveDistanceKm",
                            "type": "number",
                            "label": "Toplam Mesafe",
                            "unit": "km",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "consumedLitres",
                            "type": "number",
                            "label": "Tüketilen Yakıt",
                            "unit": "L",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "costPerKm",
                            "type": "money",
                            "label": "Kilometre Maliyeti",
                            "unit": "TL/km",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "costPer100Km",
                            "type": "money",
                            "label": "100 km Maliyeti",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "totalCost",
                            "type": "money",
                            "label": "Toplam Yakıt Maliyeti",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": true
                        }
                    ]
                },
                "content": {
                    "title": "Yakıt Tüketim Maliyeti Hesaplama: Arabanız Ne Yakar?",
                    "shortTitle": "Yakıt Tüketimi",
                    "summary": "Mesafe, ortalama tüketim ve litre fiyatından yolculukta harcanacak yakıtı, kilometre maliyetini ve toplam yakıt giderini hesaplar.",
                    "method": "Gidiş-dönüş seçilirse girilen tek yön mesafesi ikiyle çarpılır. Toplam mesafe ile L/100 km tüketim değeri kullanılarak tüketilecek litre bulunur; litre fiyatı bu miktarla çarpılarak toplam maliyet hesaplanır. Kilometre ve 100 kilometre başına maliyet aynı kullanıcı girdilerinden türetilir.",
                    "limitations": [
                        "Yalnız kullanıcı girdili aritmetik; dış tarife yok. Yakıt türü yalnız etikettir; fiyat ve tüketim otomatik atanmaz.",
                        "Trafik, sürüş tarzı, yük, lastik, yol eğimi, hava koşulu ve aracın mekanik durumu gerçek tüketimi değiştirebilir; araç bu değişkenleri modellemez.",
                        "Sonuç bütçe tahminidir; fiilî pompa veya araç bilgisayarı ölçümü değildir."
                    ],
                    "faqs": [
                        {
                            "question": "Yakıt türünü seçmek litre fiyatını değiştirir mi?",
                            "answer": "Hayır. Benzin, motorin veya LPG seçimi yalnız sonuç etiketidir. Güncel litre fiyatını ve kendi aracınızın ortalama tüketimini siz girmelisiniz."
                        },
                        {
                            "question": "Gidiş-dönüş seçimi nasıl hesaplanır?",
                            "answer": "Girilen mesafe tek yön kabul edilir ve ikiyle çarpılır. Tüketilen litre ile toplam maliyet bu iki kat mesafe üzerinden hesaplanır."
                        },
                        {
                            "question": "Araç bilgisayarındaki değerle sonuç neden farklı olabilir?",
                            "answer": "Bu araç girdiğiniz sabit L/100 km değerini kullanır. Gerçek tüketim trafik, hız, yük, hava ve ölçüm yöntemine göre değişebileceği için pompa veya araç bilgisayarı sonucu farklı olabilir."
                        }
                    ],
                    "sourcePanel": {
                        "title": "Kaynak ve veri kapsamı",
                        "summary": "Canlı akaryakıt fiyatı veya marka-model tüketim verisi kullanılmaz. Mesafe, L/100 km ve TL/L değerleri kullanıcı girdisidir; sourceIds boş kalır.",
                        "sourceIds": [],
                        "notes": [
                            "Yakıt türü seçimi dış veri çağırmaz.",
                            "Yöntem dönemsel oran veya mevzuat içermez."
                        ]
                    }
                },
                "config": {
                    "kind": "fuel-consumption-v1",
                    "metadata": {
                        "calculatorId": "fuel-consumption",
                        "version": "1.0.0",
                        "effectiveFrom": "2026-08-20",
                        "lastVerifiedAt": "2026-08-20",
                        "sources": [],
                        "notes": [
                            "Tüketim ve litre fiyatı kullanıcı girdisidir; yakıt türüne göre otomatik fiyat veya tüketim atanmaz."
                        ]
                    },
                    "distanceKm": [
                        1,
                        20000
                    ],
                    "consumptionL100Km": [
                        1,
                        50
                    ],
                    "pricePerLitre": [
                        1,
                        500
                    ]
                },
                "lastReviewed": "2026-08-20"
            }
        },
        {
            "canonicalToolId": "ticari-muhasebe.kar-marji-ve-satis-fiyati-hesaplama",
            "runtimeToolId": "profit-margin",
            "contractCanonicalSha256": "a7d7301bbdabeca1255b22580d46634c2a91a2b4e3149bb9013272b90db6dff6",
            "oracleRecordSha256": "b205183c28e3b1089666c96c342af942cbd6a93e77dd782998577f0f0a680cc2",
            "contract": {
                "toolId": "profit-margin",
                "slug": "kar-marji-ve-satis-fiyati-hesaplama",
                "path": "/ticari-muhasebe/kar-marji-ve-satis-fiyati-hesaplama",
                "category": {
                    "id": "ticari-muhasebe",
                    "label": "Ticari ve Muhasebe"
                },
                "classification": "timeless",
                "engineId": "profit-margin-v2",
                "schemaVersion": "2.0.0",
                "contentVersion": "2026.8.24",
                "configVersion": "2.0.0",
                "effectiveFrom": "2026-08-24",
                "effectiveTo": null,
                "minAppVersion": "0.2.0",
                "updateCadence": {
                    "mode": "method-change-only",
                    "days": null,
                    "reviewAfter": null,
                    "specialMonths": [],
                    "note": "Aritmetik yöntem değişmedikçe kural güncellemesi gerekmez; yıllık işlev ve metin QA'sı yapılabilir."
                },
                "sources": [],
                "inputSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "mode",
                            "type": "radio",
                            "label": "Ne yapmak istiyorsunuz?",
                            "required": true,
                            "defaultValue": "targetSaleMargin",
                            "placeholder": null,
                            "unit": null,
                            "minimum": null,
                            "maximum": null,
                            "maxDecimalPlaces": null,
                            "options": [
                                {
                                    "value": "targetSaleMargin",
                                    "label": "Satış fiyatının belirli yüzdesi kâr olsun"
                                },
                                {
                                    "value": "costMarkup",
                                    "label": "Maliyetin üzerine belirli yüzde ekle"
                                },
                                {
                                    "value": "analyzeSale",
                                    "label": "Mevcut satışın kârlılığını gör"
                                }
                            ],
                            "visibleWhen": null
                        },
                        {
                            "id": "cost",
                            "type": "number",
                            "label": "Maliyet",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 100",
                            "unit": "TL",
                            "minimum": 0.01,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "targetMarginPercent",
                            "type": "number",
                            "label": "Hedef Satış Marjı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 30",
                            "unit": "%",
                            "minimum": 0,
                            "maximum": 99.99,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": {
                                "fieldId": "mode",
                                "equals": "targetSaleMargin"
                            }
                        },
                        {
                            "id": "markupPercent",
                            "type": "number",
                            "label": "Maliyete Kâr Ekleme Oranı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 30",
                            "unit": "%",
                            "minimum": 0,
                            "maximum": 1000000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": {
                                "fieldId": "mode",
                                "equals": "costMarkup"
                            }
                        },
                        {
                            "id": "salePrice",
                            "type": "number",
                            "label": "Mevcut Satış Fiyatı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 130",
                            "unit": "TL",
                            "minimum": 0.01,
                            "maximum": 1000000000,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": {
                                "fieldId": "mode",
                                "equals": "analyzeSale"
                            }
                        }
                    ]
                },
                "resultSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "mode",
                            "type": "text",
                            "label": "Hesap Türü",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "cost",
                            "type": "money",
                            "label": "Maliyet",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "salePrice",
                            "type": "money",
                            "label": "Satış Fiyatı",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "profit",
                            "type": "money",
                            "label": "Kâr veya Zarar",
                            "unit": "TL",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "markupPercent",
                            "type": "percentage",
                            "label": "Maliyete Göre Kâr Ekleme Oranı",
                            "unit": "%",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "marginPercent",
                            "type": "percentage",
                            "label": "Satış Fiyatındaki Kâr Marjı",
                            "unit": "%",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "isLoss",
                            "type": "boolean",
                            "label": "Zarar Durumu",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        }
                    ]
                },
                "content": {
                    "title": "Kâr Marjı, Kâr Ekleme Oranı ve Satış Fiyatı Hesaplama",
                    "shortTitle": "Kâr Marjı",
                    "summary": "Hedef satış marjından veya maliyete eklenecek orandan satış fiyatını bulur; mevcut satış fiyatının kârını, zararını ve iki yüzdeyi de ayrı gösterir.",
                    "method": "Hedef satış marjı modunda maliyet, bir eksi marj oranına bölünür; böylece kâr satış fiyatının seçilen yüzdesi olur. Kâr ekleme modunda oran doğrudan maliyete uygulanır. Mevcut satış analizi modunda satıştan maliyet çıkarılır. Kâr ekleme oranı kârın maliyete, satış marjı ise kârın satış fiyatına oranıdır ve aynı yüzde değildir.",
                    "limitations": [
                        "Yalnız kullanıcı girdili aritmetik; dış tarife yok. Vergi, KDV, komisyon, kargo, işçilik ve diğer giderler otomatik eklenmez.",
                        "Gerçek kârlılık için bütün giderler maliyet alanına kullanıcı tarafından dahil edilmelidir.",
                        "Araç muhasebe kaydı, vergi beyanı, fiyatlandırma tavsiyesi veya mevzuat yorumu üretmez."
                    ],
                    "faqs": [
                        {
                            "question": "Kâr marjı ile kâr ekleme oranı aynı mıdır?",
                            "answer": "Hayır. Kâr ekleme oranı kârın maliyete, satış marjı ise kârın satış fiyatına oranıdır. 100 TL maliyetin üzerine %30 eklendiğinde satış 130 TL, satış marjı ise yaklaşık %23,08 olur."
                        },
                        {
                            "question": "100 TL maliyette %30 satış marjı için fiyat neden 130 TL değildir?",
                            "answer": "Çünkü 130 TL, maliyete %30 eklenmiş fiyattır. Kârın satışın %30'u olması için 100 TL maliyet 1 - 0,30 değerine bölünür ve satış fiyatı yaklaşık 142,86 TL olur."
                        },
                        {
                            "question": "Hedef satış marjına göre fiyat nasıl bulunur?",
                            "answer": "Maliyet, 1 eksi hedef marj oranına bölünür. Hedef marj yüzde 100 olamaz; pozitif maliyetle sonlu bir satış fiyatı üretmez."
                        },
                        {
                            "question": "Maliyetin üzerine oran ekleyerek fiyat nasıl bulunur?",
                            "answer": "Maliyet, 1 artı kâr ekleme oranıyla çarpılır. Yüzde sıfır seçilirse satış maliyete eşit olur ve başabaş sonucu çıkar."
                        },
                        {
                            "question": "Satış fiyatı maliyetin altındaysa ne olur?",
                            "answer": "Araç farkı zarar olarak gösterir. Kâr veya zarar tutarıyla birlikte maliyete göre oran ve satış marjı negatif çıkar; satış fiyatını değiştirmez veya gizlemez."
                        },
                        {
                            "question": "KDV ve komisyon hesaba dahil midir?",
                            "answer": "Hayır. KDV, pazar yeri komisyonu, kargo, işçilik ve benzeri giderler ayrıca modellenmez. Karşılaştırmak istediğiniz gerçek toplam maliyete bu kalemleri kendiniz eklemelisiniz."
                        }
                    ],
                    "sourcePanel": {
                        "title": "Yöntem ve veri kapsamı",
                        "summary": "Dış oran veya canlı tarife kullanılmaz. Araç yalnız girilen maliyet, hedef satış marjı, kâr ekleme oranı veya satış fiyatına kapalı aritmetik uygular; sourceIds boş kalır.",
                        "sourceIds": [],
                        "notes": [
                            "Vergi ve gider oranları çekirdeğe gömülü değildir.",
                            "Aritmetik yöntem değişmedikçe yalnız yıllık işlev ve metin kontrolü gerekir."
                        ]
                    }
                },
                "config": {
                    "kind": "profit-margin-v2",
                    "metadata": {
                        "calculatorId": "profit-margin",
                        "version": "2.0.0",
                        "effectiveFrom": "2026-08-24",
                        "lastVerifiedAt": "2026-08-24",
                        "sources": [],
                        "notes": [
                            "Satış marjı kârın satış fiyatına, kâr ekleme oranı ise kârın maliyete oranıdır; bu iki yüzde aynı değildir.",
                            "Vergi, komisyon ve diğer giderler kullanıcı tarafından maliyete dahil edilmelidir."
                        ]
                    },
                    "monetaryInput": [
                        0.01,
                        1000000000
                    ],
                    "targetMarginPercent": [
                        0,
                        99.99
                    ],
                    "markupPercent": [
                        0,
                        1000000
                    ]
                },
                "lastReviewed": "2026-08-24"
            }
        },
        {
            "canonicalToolId": "saglik-yasam.bazal-metabolizma-hesaplama",
            "runtimeToolId": "basal-metabolic-rate",
            "contractCanonicalSha256": "088d94970d85627a52c33f7d6ad1983cf365c8404c3953e145e5e7d949296605",
            "oracleRecordSha256": "806259ebff62098fc7e9c590a0fcd442f8240cdb8d02d3a87dcf909664953329",
            "contract": {
                "toolId": "basal-metabolic-rate",
                "slug": "bazal-metabolizma-hesaplama",
                "path": "/saglik-yasam/bazal-metabolizma-hesaplama",
                "category": {
                    "id": "saglik-yasam",
                    "label": "Sağlık ve Yaşam"
                },
                "classification": "timeless",
                "engineId": "basal-metabolic-rate-v1",
                "schemaVersion": "1.0.0",
                "contentVersion": "2026.8.20",
                "configVersion": "1.0.0",
                "effectiveFrom": "2026-08-20",
                "effectiveTo": null,
                "minAppVersion": "0.1.0",
                "updateCadence": {
                    "mode": "method-change-only",
                    "days": null,
                    "reviewAfter": null,
                    "specialMonths": [],
                    "note": "Denklem kodu yalnız yöntem değişiminde güncellenir; ayrı bakım sınıfı kaynak metodolojisini yılda bir insan incelemesine bağlar."
                },
                "sources": [
                    {
                        "sourceId": "mifflin-1990-pmid-2305711",
                        "sourceGroupId": null,
                        "title": "A new predictive equation for resting energy expenditure in healthy individuals",
                        "publisher": "The American Journal of Clinical Nutrition / PubMed",
                        "url": "https://pubmed.ncbi.nlm.nih.gov/2305711/",
                        "kind": "peer-reviewed-medical-research",
                        "reviewedOn": "2026-08-20",
                        "watchFields": [
                            "denklem kapsamı",
                            "19–78 yaş örneklem kapsamı",
                            "tahmin niteliği"
                        ]
                    },
                    {
                        "sourceId": "roza-shizgal-1984-pmid-6741850",
                        "sourceGroupId": null,
                        "title": "The Harris Benedict equation reevaluated",
                        "publisher": "The American Journal of Clinical Nutrition / PubMed",
                        "url": "https://pubmed.ncbi.nlm.nih.gov/6741850/",
                        "kind": "peer-reviewed-medical-research",
                        "reviewedOn": "2026-08-20",
                        "watchFields": [
                            "denklem kapsamı",
                            "yaş sınırı belirsizliği",
                            "tahmin niteliği"
                        ]
                    },
                    {
                        "sourceId": "muller-2001-pmid-11817239",
                        "sourceGroupId": null,
                        "title": "Calculating the basal metabolic rate and severe and morbid obesity",
                        "publisher": "Praxis / PubMed",
                        "url": "https://pubmed.ncbi.nlm.nih.gov/11817239/",
                        "kind": "peer-reviewed-medical-research",
                        "reviewedOn": "2026-08-20",
                        "watchFields": [
                            "revize Harris–Benedict katsayılarının görünür doğrulaması",
                            "köken yayını olmadığı kanıt sınırı"
                        ]
                    }
                ],
                "inputSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "sex",
                            "type": "radio",
                            "label": "Biyolojik Cinsiyet",
                            "required": true,
                            "defaultValue": "erkek",
                            "placeholder": null,
                            "unit": null,
                            "minimum": null,
                            "maximum": null,
                            "maxDecimalPlaces": null,
                            "options": [
                                {
                                    "value": "erkek",
                                    "label": "Erkek"
                                },
                                {
                                    "value": "kadin",
                                    "label": "Kadın"
                                }
                            ],
                            "visibleWhen": null
                        },
                        {
                            "id": "formula",
                            "type": "select",
                            "label": "Denklem",
                            "required": true,
                            "defaultValue": "mifflin",
                            "placeholder": null,
                            "unit": null,
                            "minimum": null,
                            "maximum": null,
                            "maxDecimalPlaces": null,
                            "options": [
                                {
                                    "value": "mifflin",
                                    "label": "Mifflin–St Jeor"
                                },
                                {
                                    "value": "harris",
                                    "label": "Revize Harris–Benedict"
                                }
                            ],
                            "visibleWhen": null
                        },
                        {
                            "id": "ageYears",
                            "type": "number",
                            "label": "Yaş",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 30",
                            "unit": "yıl",
                            "minimum": 18,
                            "maximum": 100,
                            "maxDecimalPlaces": 0,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "heightCm",
                            "type": "number",
                            "label": "Boy",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 180",
                            "unit": "cm",
                            "minimum": 100,
                            "maximum": 250,
                            "maxDecimalPlaces": 1,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "weightKg",
                            "type": "number",
                            "label": "Vücut Ağırlığı",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 75",
                            "unit": "kg",
                            "minimum": 20,
                            "maximum": 300,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        }
                    ]
                },
                "resultSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "sex",
                            "type": "text",
                            "label": "Biyolojik Cinsiyet",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "formula",
                            "type": "text",
                            "label": "Seçilen Denklem",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "ageYears",
                            "type": "number",
                            "label": "Yaş",
                            "unit": "yıl",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "heightCm",
                            "type": "number",
                            "label": "Boy",
                            "unit": "cm",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "weightKg",
                            "type": "number",
                            "label": "Vücut Ağırlığı",
                            "unit": "kg",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "mifflinKcalPerDay",
                            "type": "number",
                            "label": "Mifflin–St Jeor Tahmini",
                            "unit": "kcal/gün",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "revisedHarrisBenedictKcalPerDay",
                            "type": "number",
                            "label": "Revize Harris–Benedict Tahmini",
                            "unit": "kcal/gün",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "selectedKcalPerDay",
                            "type": "number",
                            "label": "Seçilen Günlük Tahmin",
                            "unit": "kcal/gün",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "selectedKcalPerHour",
                            "type": "number",
                            "label": "Saatlik Karşılık",
                            "unit": "kcal/saat",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "selectedSourceScope",
                            "type": "text",
                            "label": "Kaynak Kapsamı",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "selectedSourceScopeNote",
                            "type": "text",
                            "label": "Kaynak Kapsam Notu",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        }
                    ]
                },
                "content": {
                    "title": "Dinlenme Enerji Harcaması Tahmini",
                    "shortTitle": "Dinlenme Enerjisi",
                    "summary": "Biyolojik cinsiyet, yaş, boy ve ağırlıktan Mifflin–St Jeor veya revize Harris–Benedict yöntemiyle günlük dinlenme enerji harcaması tahmini üretir.",
                    "method": "Araç iki yöntemin günlük kcal tahminini aynı girdilerden hesaplar ve seçilen yöntemin sonucunu öne çıkarır. Saatlik karşılık günlük tahminin 24'e bölünmesiyle gösterilir. Mifflin–St Jeor seçildiğinde yaş, kaynak çalışmanın 19–78 yaş örneklemiyle karşılaştırılır; 18 ve 79–100 yaş değerleri ekstrapolasyon olarak etiketlenir. Revize Harris–Benedict seçildiğinde birincil PubMed özetinde kesin yaş sınırı bulunmadığı ayrıca belirtilir.",
                    "limitations": [
                        "Sonuç dinlenme enerji harcaması tahminidir; doğrudan kalorimetri ölçümü, tıbbi tanı, tedavi veya kişisel kalori reçetesi değildir.",
                        "Mifflin–St Jeor çalışmasının örneklemi 19–78 yaştır. Aracın yetişkin girdi sınırı 18–100 olsa da 18 ve 79–100 yaş sonuçları bu kaynak bakımından ekstrapolasyondur.",
                        "Roza–Shizgal özeti kesin yaş alt ve üst sınırını yayımlamaz; normal beslenenlerde yaklaşık ±%14 hassasiyet bildirir ve malnütrisyonda denklemi güvenilmez bulur.",
                        "Hastalık, gebelik, ateş, kas kütlesi, ilaçlar ve klinik durum gerçek enerji harcamasını değiştirebilir."
                    ],
                    "faqs": [
                        {
                            "question": "18 yaş neden Mifflin–St Jeor için ekstrapolasyon sayılır?",
                            "answer": "Birincil çalışma 19–78 yaş katılımcıları kapsar. Araç yetişkin başlangıcı olarak 18 yaş girdisini kabul eder; ancak 18 yaş kaynak örnekleminin dışında olduğu için sonuç açıkça ekstrapolasyon olarak işaretlenir."
                        },
                        {
                            "question": "Mifflin–St Jeor ile revize Harris–Benedict'ten hangisi kesin sonuç verir?",
                            "answer": "Hiçbiri kesin ölçüm değildir. İki yöntem de boy, ağırlık, yaş ve biyolojik cinsiyetten istatistiksel tahmin üretir; doğrudan ölçüm için indirekt kalorimetri ve sağlık uzmanı değerlendirmesi gerekir."
                        },
                        {
                            "question": "Bu sonuç günlük toplam kalori ihtiyacım mıdır?",
                            "answer": "Hayır. Sonuç yalnız dinlenme enerji harcaması tahminidir. Günlük toplam enerji ihtiyacı için hareket, egzersiz, besinlerin termik etkisi ve kişisel sağlık koşulları ayrıca değerlendirilmelidir."
                        },
                        {
                            "question": "Revize Harris–Benedict için yaş kapsamı neden belirsiz gösterilir?",
                            "answer": "Roza–Shizgal'ın PubMed özetinde daha geniş yaş aralığından ek veriler kullanıldığı yazsa da kesin alt ve üst yaş sınırları verilmez. Araç kanıtlanmamış bir yaş aralığı uydurmak yerine bu sınırı kullanıcıya gösterir."
                        }
                    ],
                    "sourcePanel": {
                        "title": "Bilimsel kaynaklar ve kanıt sınırı",
                        "summary": "Mifflin–St Jeor için birincil yöntem ve yaş örneklemi; revize Harris–Benedict için birincil yöntem kaydı ile katsayıları açıkça gösteren ek doğrulama kaydı birlikte sunulur.",
                        "sourceIds": [
                            "mifflin-1990-pmid-2305711",
                            "roza-shizgal-1984-pmid-6741850",
                            "muller-2001-pmid-11817239"
                        ],
                        "notes": [
                            "PMID 2305711 exact Mifflin–St Jeor denklemlerini ve 19–78 yaş örneklemini yayımlar.",
                            "PMID 6741850 köken yöntem kaynağıdır; PubMed özeti exact yaş sınırlarını ve katsayıları göstermez.",
                            "PMID 11817239 revize Harris–Benedict katsayılarını görünür biçimde doğrular; köken yayını değildir."
                        ]
                    }
                },
                "config": {
                    "kind": "basal-metabolic-rate-v1",
                    "metadata": {
                        "calculatorId": "basal-metabolic-rate",
                        "version": "1.0.0",
                        "effectiveFrom": "2026-08-20",
                        "lastVerifiedAt": "2026-08-20",
                        "sources": [
                            {
                                "id": "mifflin-1990-pmid-2305711",
                                "title": "A new predictive equation for resting energy expenditure in healthy individuals",
                                "publisher": "The American Journal of Clinical Nutrition / PubMed",
                                "url": "https://pubmed.ncbi.nlm.nih.gov/2305711/",
                                "verifiedAt": "2026-08-20"
                            },
                            {
                                "id": "roza-shizgal-1984-pmid-6741850",
                                "title": "The Harris Benedict equation reevaluated",
                                "publisher": "The American Journal of Clinical Nutrition / PubMed",
                                "url": "https://pubmed.ncbi.nlm.nih.gov/6741850/",
                                "verifiedAt": "2026-08-20"
                            }
                        ],
                        "notes": [
                            "Formüller dinlenme enerji harcamasını tahmin eder; ölçüm veya tıbbi tanı değildir.",
                            "Mifflin–St Jeor çalışması 19–78 yaş katılımcıları kapsar; bu aralığın dışındaki sonuç ekstrapolasyon olarak etiketlenir.",
                            "Roza–Shizgal PubMed özetinde kesin alt ve üst yaş sınırı verilmediğinden seçili Harris sonucu bu belirsizlikle etiketlenir.",
                            "Yetişkin kapsamı ve metodoloji yılda bir kaynak incelemesinden geçirilmelidir."
                        ]
                    },
                    "ageYears": [
                        18,
                        100
                    ],
                    "heightCm": [
                        100,
                        250
                    ],
                    "weightKg": [
                        20,
                        300
                    ]
                },
                "lastReviewed": "2026-08-20"
            }
        },
        {
            "canonicalToolId": "saglik-yasam.ideal-kilo-hesaplama",
            "runtimeToolId": "historical-ideal-weight-reference",
            "contractCanonicalSha256": "1648fef16cb592d896573b856df257c4539544ae1f0141457f6dde4344edc441",
            "oracleRecordSha256": "37d199556d55fcc2ce81e0afe2beccfbc164ad9af654d8a250180a2b13ef36b7",
            "contract": {
                "toolId": "historical-ideal-weight-reference",
                "slug": "ideal-kilo-hesaplama",
                "path": "/saglik-yasam/ideal-kilo-hesaplama",
                "category": {
                    "id": "saglik-yasam",
                    "label": "Sağlık ve Yaşam"
                },
                "classification": "timeless",
                "engineId": "historical-ideal-weight-reference-v1",
                "schemaVersion": "1.0.0",
                "contentVersion": "2026.8.20",
                "configVersion": "1.0.0",
                "effectiveFrom": "2026-08-20",
                "effectiveTo": null,
                "minAppVersion": "0.1.0",
                "updateCadence": {
                    "mode": "method-change-only",
                    "days": null,
                    "reviewAfter": null,
                    "specialMonths": [],
                    "note": "Denklem kodu yalnız yöntem değişiminde güncellenir; ayrı bakım sınıfı kaynak metodolojisini yılda bir insan incelemesine bağlar."
                },
                "sources": [
                    {
                        "sourceId": "peterson-2016-pmc4841935",
                        "sourceGroupId": null,
                        "title": "Universal equation for estimating ideal body weight and body weight at any BMI",
                        "publisher": "The American Journal of Clinical Nutrition / PubMed Central",
                        "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4841935/",
                        "kind": "peer-reviewed-medical-research",
                        "reviewedOn": "2026-08-20",
                        "watchFields": [
                            "tarihsel denklem kapsamı",
                            "beş fit referans noktası",
                            "kişisel hedef olmama uyarısı"
                        ]
                    },
                    {
                        "sourceId": "stachowska-2020-pmc7353890",
                        "sourceGroupId": null,
                        "title": "Nutritional Support in Coronavirus 2019 Disease",
                        "publisher": "Medicina / PubMed Central",
                        "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7353890/",
                        "kind": "peer-reviewed-medical-research",
                        "reviewedOn": "2026-08-20",
                        "watchFields": [
                            "metrik yuvarlanmış Hamwi katsayıları",
                            "özgün Hamwi yayını olmadığı kanıt sınırı"
                        ]
                    },
                    {
                        "sourceId": "robinson-1983-pmid-6869387",
                        "sourceGroupId": null,
                        "title": "Determination of ideal body weight for drug dosage calculations",
                        "publisher": "American Journal of Hospital Pharmacy / PubMed",
                        "url": "https://pubmed.ncbi.nlm.nih.gov/6869387/",
                        "kind": "peer-reviewed-medical-research",
                        "reviewedOn": "2026-08-20",
                        "watchFields": [
                            "özgün Robinson katsayıları",
                            "ilaç dozu bağlamı",
                            "v1 yuvarlama farkı"
                        ]
                    }
                ],
                "inputSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "sex",
                            "type": "radio",
                            "label": "Biyolojik Cinsiyet",
                            "required": true,
                            "defaultValue": "erkek",
                            "placeholder": null,
                            "unit": null,
                            "minimum": null,
                            "maximum": null,
                            "maxDecimalPlaces": null,
                            "options": [
                                {
                                    "value": "erkek",
                                    "label": "Erkek"
                                },
                                {
                                    "value": "kadin",
                                    "label": "Kadın"
                                }
                            ],
                            "visibleWhen": null
                        },
                        {
                            "id": "heightCm",
                            "type": "number",
                            "label": "Boy",
                            "required": true,
                            "defaultValue": null,
                            "placeholder": "Ör: 180",
                            "unit": "cm",
                            "minimum": 140,
                            "maximum": 220,
                            "maxDecimalPlaces": 1,
                            "options": [],
                            "visibleWhen": null
                        },
                        {
                            "id": "currentWeightKg",
                            "type": "number",
                            "label": "Mevcut Vücut Ağırlığı",
                            "required": false,
                            "defaultValue": null,
                            "placeholder": "İsteğe bağlı; ör: 75",
                            "unit": "kg",
                            "minimum": 30,
                            "maximum": 250,
                            "maxDecimalPlaces": 2,
                            "options": [],
                            "visibleWhen": null
                        }
                    ]
                },
                "resultSchema": {
                    "type": "object",
                    "fields": [
                        {
                            "id": "sex",
                            "type": "text",
                            "label": "Biyolojik Cinsiyet",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "heightCm",
                            "type": "number",
                            "label": "Boy",
                            "unit": "cm",
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "currentWeightKg",
                            "type": "number",
                            "label": "Mevcut Vücut Ağırlığı",
                            "unit": "kg",
                            "nullable": true,
                            "prominent": false
                        },
                        {
                            "id": "devineKg",
                            "type": "number",
                            "label": "Devine Referansı",
                            "unit": "kg",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "robinsonKg",
                            "type": "number",
                            "label": "Robinson Referansı",
                            "unit": "kg",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "hamwiKg",
                            "type": "number",
                            "label": "Hamwi Referansı",
                            "unit": "kg",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "referenceMinimumKg",
                            "type": "number",
                            "label": "Referans Aralığı Alt Sınırı",
                            "unit": "kg",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "referenceMaximumKg",
                            "type": "number",
                            "label": "Referans Aralığı Üst Sınırı",
                            "unit": "kg",
                            "nullable": false,
                            "prominent": true
                        },
                        {
                            "id": "currentPosition",
                            "type": "text",
                            "label": "Mevcut Konum",
                            "unit": null,
                            "nullable": true,
                            "prominent": false
                        },
                        {
                            "id": "differenceFromRangeKg",
                            "type": "number",
                            "label": "Referans Aralığına Fark",
                            "unit": "kg",
                            "nullable": true,
                            "prominent": false
                        },
                        {
                            "id": "heightSourceScope",
                            "type": "text",
                            "label": "Boy Kaynak Kapsamı",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        },
                        {
                            "id": "heightSourceScopeNote",
                            "type": "text",
                            "label": "Boy Kaynak Kapsam Notu",
                            "unit": null,
                            "nullable": false,
                            "prominent": false
                        }
                    ]
                },
                "content": {
                    "title": "Referans Vücut Ağırlığı Denklem Karşılaştırması",
                    "shortTitle": "Referans Vücut Ağırlığı",
                    "summary": "Boy ve biyolojik cinsiyetten Devine, Peterson tablosundaki yuvarlanmış Robinson ve metrik yuvarlanmış Hamwi sonuçlarını yan yana gösterir.",
                    "method": "Boy santimetreden inçe çevrilir ve 5 fit, yani 60 inç üzerindeki fark bulunur. Bu fark Devine, yuvarlanmış Robinson ve metrik yuvarlanmış Hamwi katsayılarıyla ayrı ayrı değerlendirilir. En düşük ve en yüksek sonuç karşılaştırma aralığını oluşturur; mevcut ağırlık isteğe bağlı girilmişse bu aralığa göre yalnız sayısal konum gösterilir. 152,4 cm altındaki hesap geriye matematiksel ekstrapolasyon olarak etiketlenir.",
                    "limitations": [
                        "Devine, Robinson ve Hamwi tarihsel referanslardır; kişisel olarak olmanız gereken kilo, tıbbi tanı, tedavi hedefi veya ilaç dozu önerisi değildir.",
                        "Araç v1 yalnız Devine, Robinson ve Hamwi sonuçlarını uygular. Peterson karşılaştırmasında yer alan Miller denklemi v1 kapsamı dışındadır.",
                        "Robinson sonucu özgün makaledeki ondalıklı katsayılar yerine Peterson 2016 Tablo 3'teki yuvarlanmış gösterimi; Hamwi sonucu ise kaynakta açıkça gösterilen metrik yuvarlanmış varyantı kullanır.",
                        "Kaynak gösterim 5 fit ve üzerini temel alır. 152,4 cm altındaki sonuç yalnız geriye ekstrapolasyondur ve doğrulanmış klinik hedef sayılmaz.",
                        "Yaş, vücut kompozisyonu, kas kütlesi, gebelik, hastalık ve kişisel sağlık hedefleri bu tarihsel denklemlerde yer almaz."
                    ],
                    "faqs": [
                        {
                            "question": "Üç referans sonucu neden birbirinden farklıdır?",
                            "answer": "Denklemler farklı tarihlerde, amaçlarla ve katsayılarla hazırlanmıştır. Evrensel tek bir ideal kilo üretmezler; bu nedenle sonuçlar tek hedef yerine tarihsel yöntem karşılaştırması olarak gösterilir."
                        },
                        {
                            "question": "152,4 santimetrenin altındaki sonuç nasıl yorumlanmalıdır?",
                            "answer": "Kaynak gösterim 60 inç, yani 152,4 santimetre ve üzerini temel alır. Daha kısa boyda denklem geriye doğru işletilir; sonuç matematiksel ekstrapolasyondur ve klinik hedef değildir."
                        },
                        {
                            "question": "Miller denklemi neden sonuçlarda yer almıyor?",
                            "answer": "Peterson 2016 karşılaştırma tablosu Miller denklemini de listeler; ancak HepHesapla v1 mevcut web aracıyla aynı kapsamda yalnız Devine, Robinson ve Hamwi'yi uygular. Miller v1 kapsamı dışındadır."
                        },
                        {
                            "question": "Robinson sonucu neden özgün makaledeki katsayılardan farklı görünebilir?",
                            "answer": "Özgün Robinson özeti ondalıklı katsayılar yayımlar. HepHesapla v1, Peterson 2016 Tablo 3'te verilen yuvarlanmış Robinson gösterimini kullanır ve kaynak panelinde bu farkı gizlemez."
                        },
                        {
                            "question": "Mevcut ağırlığımı girmek zorunda mıyım?",
                            "answer": "Hayır. Mevcut ağırlık isteğe bağlıdır. Girilmezse üç tarihsel sonuç ve bunların sayısal alt-üst aralığı gösterilir; mevcut ağırlığa ilişkin konum veya fark üretilmez."
                        }
                    ],
                    "sourcePanel": {
                        "title": "Bilimsel kaynaklar ve yöntem sürümü",
                        "summary": "Peterson 2016 tarihsel denklemleri ve 5 fit sınırını karşılaştırır; ek kaynaklar kullanılan metrik Hamwi varyantını ve Robinson'ın özgün katsayı kökenini şeffaflaştırır.",
                        "sourceIds": [
                            "peterson-2016-pmc4841935",
                            "stachowska-2020-pmc7353890",
                            "robinson-1983-pmid-6869387"
                        ],
                        "notes": [
                            "PMC4841935 Tablo 3 Devine, yuvarlanmış Robinson, Hamwi ve Miller gösterimlerini; metin ise 60 inç alt sınırını yayımlar.",
                            "PMC7353890 HepHesapla v1 ile aynı metrik yuvarlanmış Hamwi katsayılarını gösterir; özgün 1964 Hamwi yayını değildir.",
                            "PMID 6869387 Robinson'ın özgün ondalıklı katsayılarını ve ilaç dozu bağlamını gösterir; v1 Peterson tablosundaki yuvarlanmış gösterimi kullanır.",
                            "Miller kaynakta görünür fakat v1 engine ve sonuç şemasında yer almaz."
                        ]
                    }
                },
                "config": {
                    "kind": "historical-ideal-weight-reference-v1",
                    "metadata": {
                        "calculatorId": "historical-ideal-weight-reference",
                        "version": "1.0.0",
                        "effectiveFrom": "2026-08-20",
                        "lastVerifiedAt": "2026-08-20",
                        "sources": [
                            {
                                "id": "peterson-2016-pmc4841935",
                                "title": "Universal equation for estimating ideal body weight and body weight at any BMI",
                                "publisher": "The American Journal of Clinical Nutrition / PubMed Central",
                                "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4841935/",
                                "verifiedAt": "2026-08-20"
                            }
                        ],
                        "notes": [
                            "Devine, Robinson ve Hamwi çıktıları tarihsel referans formülleridir; kişisel hedef, tanı veya tedavi önerisi değildir.",
                            "Formüller beş fitin altındaki boylarda doğrulanmış klinik hedef olarak yorumlanmamalıdır.",
                            "Metodoloji ve kapsam yılda bir kaynak incelemesinden geçirilmelidir."
                        ]
                    },
                    "heightCm": [
                        140,
                        220
                    ],
                    "optionalCurrentWeightKg": [
                        30,
                        250
                    ]
                },
                "lastReviewed": "2026-08-20"
            }
        }
    ]
};
